/** Review rows that are still flagged. Approved rows are left alone. */
export function failedReviewResultIds(results: unknown): string[] {
  if (!results || typeof results !== 'object') {
    return [];
  }
  const rows = (results as { reviewResults?: unknown }).reviewResults;
  if (!Array.isArray(rows)) {
    return [];
  }
  const ids: string[] = [];
  for (const row of rows) {
    if (!row || typeof row !== 'object') {
      continue;
    }
    const id = (row as { id?: unknown }).id;
    const answer = (row as { answer?: unknown }).answer;
    if (typeof id !== 'string' || id.length === 0) {
      continue;
    }
    if (typeof answer === 'string' && answer.toLowerCase() === 'approved') {
      continue;
    }
    ids.push(id);
  }
  return ids;
}
